/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

import {
  VuexModule,
  Module,
  getModule,
  Mutation,
  Action,
  MutationAction
} from "vuex-module-decorators";
import store from "@/general/store";
import { OrganizationPageCustomizationApi } from "../../../../gen/ricapi/api";

import { OrganizationApi, Organization } from "../../../../gen/authapi/api";

import {
  FooterInfo,
  OrganizationListResult,
  OrgPageSpecific,
  UserInfo,
  UserProfileSummary
} from "@/general/store/models";
import {
  getFooterInfo,
  getOrganizationList,
  getOrganizationPageCustomizationDetails,
  getOrgSpecData
} from "../../../general/store/api";
import { checkToken } from "@/general/store/checkToken";
import { getOrganizationCustomizationData } from "@/admin/store/api";
import LocalStorage from "@/general/utils/storage";
import auth from "@/general/store/modules/auth";
import AuthApi from "@/general/api/authApi";
import { getUserProfileSummary } from "@/general/store/api";
@Module({
  name: "commons",
  store: store,
  namespaced: true,
  dynamic: true
})
class CommonModule extends VuexModule {
  // LOGIN_URL =
  // "https://icpt-auth.tst.benefit-one.inc/api/login/baccount/call_key/";
  // LOGIN_URL = "/login";
  LOGIN_URL = `${process.env.VUE_APP_AUTHORIZATION}/v1/top/login`;

  LOGOUT_URL = `https://${process.env.VUE_APP_LOGIN_API_FQDN}/authn/v1/signout`;

  [x: string]: any;
  setGrantPointList() {
    throw new Error("Method not implemented.");
  }

  colorPaletBase: any = {
    primary: {
      main: "#EE1C25",
      hover: "#FF5F66",
      pressed: "#D9161E"
    },

    blue: {
      main: "#56CDE3",
      hover: "#92EEFF",
      pressed: "#18A0B9"
    },

    green: {
      main: "#57D370",
      hover: "#8BF19F",
      pressed: "#39B552"
    },

    yellow: {
      main: "#FFBB49",
      hover: "#FDD36A",
      pressed: "#DB941E"
    },

    pink: {
      main: "#FD695D",
      hover: "#FFA097",
      pressed: "#DF4B3F"
    },

    orange: {
      main: "#ffbb49",
      hover: "#ffc76d",
      pressed: "#d79223"
    }
  };

  OrgPageSpecific: OrgPageSpecific | null = null;
  organizationListResult: OrganizationListResult | null = null;
  serviceName = ""; //"Incentive Point Program";
  // #59042対応によりserviceLogoをローカルストレージ上に保存しないように修正
  //serviceLogo = ""; //"http://127.0.0.1:10081/media/service-logo.png";
  unit: any = {
    point: "ポイント"
  };
  point: any = {};
  pointIcon = "";
  pointTotal = 0;
  pointExpiration = 0;
  pointExpirationDate = "";
  color = "primary";
  colorCode = "#ee1c25";
  colorPalet: any = {
    main: "",
    hover: "",
    pressed: ""
  };
  conditions: any = [];
  userInfo: any = {};
  headerInfo: any = {
    switch: {
      general: {
        text: "管理に切替",
        url: "/"
      },
      admin: {
        text: "一般に切替",
        url: "/"
      }
    },
    currentCategoryValue: "all",
    url: {
      cart: "/",
      favorite: "/",
      history: "/"
    },
    pageType: "general"
  };
  creditCardEnabled = true;
  itemCategories: any = [];
  breadcrumb: any = [
    {
      text: "",
      url: "/home/",
      pageType: "home"
    }
  ];
  shownHeaderItem: any = ["all"];
  selectCategoryForm: any;
  pageSize = 20;
  footer: FooterInfo | null = null;

  get getNameFromUser() {
    return (user: UserInfo) => {
      return user?.full_name;
      // return user?.kanji_name;
    };
  }

  /** サンクス機能のオンオフ */
  get thanksFunctionEnabled(): boolean {
    return this.userInfo?.thanks_point_enabled;
  }

  @Mutation
  setServiceName(serviceName: string) {
    this.serviceName = serviceName;
  }
  @Mutation
  setServiceLogo(serviceLogo: string) {
    this.serviceLogo = serviceLogo;
  }
  @Mutation
  setUnit(unit: any) {
    this.unit.point = unit.point;
  }
  @Mutation
  setPoint(point: any) {
    this.point = point;
  }
  @Mutation
  setColor(color: string) {
    this.color = color;
  }
  @Mutation
  async setColorCode(colorCode: string) {
    this.colorCode = colorCode;
  }
  @Mutation
  setColorPalet(colorPalet: any) {
    this.colorPalet = colorPalet;
  }
  @Mutation
  setContact(contact: any) {
    this.contact.siteId = contact.site_id;
    this.contact.name = contact.name;
    this.contact.email = contact.email;
    this.contact.telNumber = contact.tel_number;
  }
  @Mutation
  setConditions(conditions: any) {
    this.conditions = conditions;
  }
  @Mutation
  setUserInfo(userInfo: any) {
    this.userInfo = userInfo;
  }
  @Mutation
  setHeaderInfo(headerInfo: any) {
    this.headerInfo = headerInfo;
  }
  @Mutation
  setCreditCardEnabled(creditCardEnabled: boolean) {
    this.creditCardEnabled = creditCardEnabled;
  }
  @Mutation
  setItemCategories(itemCategories: any) {
    this.itemCategories = itemCategories;
  }
  @Mutation
  setCurrentCategory(currentCategory: any) {
    this.headerInfo.currentCategoryValue = currentCategory;
  }
  @Mutation
  updateSelectCategoryFormSearch(selectCategoryFormSearch: any) {
    this.selectCategoryForm.search = selectCategoryFormSearch;
  }
  @Mutation
  updateSelectCategoryFormCategory(selectCategoryFormCategory: any) {
    this.selectCategoryForm.category = selectCategoryFormCategory;
  }
  @Mutation
  setbreadcrumb(breadcrumb: any) {
    this.breadcrumb = breadcrumb;
  }
  @Mutation
  setShownHeaderItem(shownHeaderItem: any) {
    this.shownHeaderItem = shownHeaderItem;
  }

  @Mutation
  async setOrgPageSpecific(OrgPageSpecific: any) {
    this.OrgPageSpecific = OrgPageSpecific;
  }

  @Mutation
  setFooterInfo(footer: FooterInfo) {
    this.footer = footer;
  }

  @Action({ rawError: true })
  async getOrgPageSpecific() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const slug: string | undefined = urlParams.get("slug")?.toString();

    const org = await getOrgSpecData(slug);
    // #59042対応によりserviceLogoをローカルストレージ上に保存しないように修正
    //this.context.commit("setServiceLogo", org.page_logo);
    this.context.commit("setServiceName", org.page_title);
    // this.context.commit("setPoint", customData.point);
    this.context.commit("setColor", org.page_color);
    document.title = org.page_title;
    const link: any = document.querySelectorAll('link[rel="icon"]')[0];
    link.href = org.favicon;

    const OrgPageSpecific = {
      // #59042対応によりpage_logo、point_logo、faviconをローカルストレージ上に保存しないように修正
      organization: org.organization,
      page_title: org.page_title,
      //page_logo: org.page_logo,
      page_color: org.page_color,
      point_name: org.point_name,
      //point_logo: org.point_logo,
      //favicon: org.favicon,
      default_thanks_message: org.default_thanks_message
    };

    this.context.commit("setOrgPageSpecific", OrgPageSpecific);
  }

  @Action({ rawError: true })
  async getOrgPageSpecificById(id: number) {
    const org = await getOrganizationPageCustomizationDetails(id);

    // #59042対応によりserviceLogoをローカルストレージ上に保存しないように修正
    //this.context.commit("setServiceLogo", org.page_logo);
    this.context.commit("setServiceName", org.page_title);
    // this.context.commit("setPoint", customData.point);
    this.context.commit("setColor", org.page_color);
    document.title = org.page_title;
    const link: any = document.querySelectorAll('link[rel="icon"]')[0];
    link.href = org.favicon;

    const OrgPageSpecific = {
      // #59042対応によりpage_logo、point_logo、faviconをローカルストレージ上に保存しないように修正
      organization: org.organization,
      page_title: org.page_title,
      //page_logo: org.page_logo,
      page_color: org.page_color,
      point_name: org.point_name,
      //point_logo: org.point_logo,
      //favicon: org.favicon,
      default_thanks_message: org.default_thanks_message
    };

    this.context.commit("setOrgPageSpecific", OrgPageSpecific);
  }

  @MutationAction
  async setOrgPageSpecificDataFromLocalStorage() {
    const OrgPageSpecific = JSON.parse(
      LocalStorage.getItem("OrgSpecificData") as string
    );

    return { OrgPageSpecific };
  }

  @MutationAction
  async getOrganizationList() {
    const organizationListResult = await getOrganizationList();
    return { organizationListResult };
  }

  @Action({ rawError: true })
  async setOrgSpecificData() {
    const orgApi = new OrganizationApi();

    const org: any = await orgApi.organizationList(
      undefined,
      undefined,
      undefined
      //slug
    );

    const orgCusApi = new OrganizationPageCustomizationApi();

    const results: any = org.data.results[0].id;
    const cust: any = await orgCusApi.organizationPageCustomizationList(
      results
    );

    const pageColor = cust.data.results[0].page_color;
    const pageLogo = cust.data.results[0].page_logo;
    const pageTitle = cust.data.results[0].page_title;
    const pointName = cust.data.results[0].point_name;
    const pointLogo = cust.data.results[0].point_logo;
    const defaultThanksMessage = cust.data.results[0].default_thanks_message;
    this.context.commit("setColorCode", cust.data.results[0].page_color);
    this.context.commit("setColor", cust.data.results[0].page_color);
    // #59042対応によりserviceLogoをローカルストレージ上に保存しないように修正
    //this.context.commit("setServiceLogo", cust.data.results[0].page_logo);


  }

  @Action({ rawError: true })
  async getUserInfo() {
    const userDetails = JSON.parse(
      LocalStorage.getItem("userDetails") as string
    );
    if (userDetails != null) {
      this.context.commit("setUserInfo", userDetails);
    }
  }

  @Action({ rawError: true })
  async getUserPoints() {
    const userPoints = getUserProfileSummary();
    this.context.commit("setPoint", userPoints);
  }

  @Action({ rawError: true })
  async getCustomData() {
    const orgData = LocalStorage.getItem("OrgSpecificData") as string;
    const customData = JSON.parse(orgData);
    const customColor = customData.page_color 
      ? this.colorPaletBase[customData.page_color]
      : this.colorPaletBase["primary"];

    // const colorPalet = {
    //   main: "#FD695D",
    //   hover: "#FFA097",
    //   pressed: "#DF4B3F",
    // };
    // const colorCode = colorPalet.main;
    const unit = { point: customData.point_name };
    // #59042対応によりserviceLogoをローカルストレージ上に保存しないように修正
    //this.context.commit("setServiceLogo", customData.page_logo);
    this.context.commit("setServiceName", customData.page_title);
    this.context.commit("setUnit", unit);
    // this.context.commit("setPoint", customData.point);
    this.context.commit("setColor", customData.page_color || "primary");
    this.context.commit("setColorCode", customColor["main"]);
    this.context.commit("setColorPalet", customColor);
    // this.context.commit("setContact", customData.contact);
    // this.context.commit("setConditions", customData.conditions);
    // this.context.commit("setUserInfo", customData.user_info);
  }
  @Action({ rawError: true })
  async getCustomColor(colorKey: any) {
    const customColor = this.colorPaletBase[colorKey];
    this.context.commit("setColor", colorKey);
    this.context.commit("setColorCode", customColor["main"]);
    this.context.commit("setColorPalet", customColor);
  }
  @Action({})
  async getCreditCardEnabled(creditCardEnabled: boolean) {
    this.context.commit("setCreditCardEnabled", creditCardEnabled);
  }
  @Action({})
  getItemCategories() {
    const categories = JSON.parse(LocalStorage.getItem("categories") as string);
    this.context.commit("setItemCategories", categories);
  }

  @Action({})
  getHeaderInfo(headerInfo: any) {
    // this.context.commit("setHeaderInfo", headerInfo);
  }

  @Action({})
  async getBreadcrumb(breadcrumb: any) {
    this.context.commit("setbreadcrumb", breadcrumb);
  }
  @Action({})
  async getShownHeaderItem(shownHeaderItem: any) {
    this.context.commit("setShownHeaderItem", shownHeaderItem);
  }

  @Action({ rawError: true })
  setCustomServiceLogo(serviceLogo: string) {
    this.context.commit("setServiceLogo", serviceLogo);
  }

  @Action({ rawError: true })
  setCustomColorCode(colorCode: string) {
    this.context.commit("setColorCode", colorCode);
  }

  @Action({ rawError: true })
  setUnitName(colorCode: string) {
    this.context.commit("setUnit", colorCode);
  }

  @Action({ rawError: true })
  setFooter(footer: FooterInfo) {
    this.context.commit("setFooterInfo", footer);
  }

  public setCustomColor(customColor: any) {
    const colorPaletBase: any = {
      primary: {
        main: "#EE1C25",
        hover: "#FF5F66",
        pressed: "#D9161E"
      },

      blue: {
        main: "#56CDE3",
        hover: "#92EEFF",
        pressed: "#18A0B9"
      },

      green: {
        main: "#57D370",
        hover: "#8BF19F",
        pressed: "#39B552"
      },

      yellow: {
        main: "#FFBB49",
        hover: "#FDD36A",
        pressed: "#DB941E"
      },

      pink: {
        main: "#FD695D",
        hover: "#FFA097",
        pressed: "#DF4B3F"
      },

      orange: {
        main: "#ffbb49",
        hover: "#ffc76d",
        pressed: "#d79223"
      }
    };

    const colorPalet = colorPaletBase[customColor];
    const colorCode = colorPalet.main;

    return {
      colorCode,
      colorPalet
    };
  }
}
export default getModule(CommonModule);
